
export class PeriodoContable{
    public constructor(
        public id: String = "",
        public nombre:String = "",
        public fecha_inicio:String = "",
        public fecha_fin:String = "",
        public cierre_mensual:boolean = false,
        public dia_cierre : String = "",
        public empresa_id:String = "",
        public usuario_id:String = null,
        public status: String = "",

    ){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/periodo-contable.ts